import 'animate.css'
import './assets/css/main.css'
import './assets/css/tailwind.include.css'
import './utils/plugins/ripple.js'
import './utils/plugins/swipper.js'
import './utils/plugins/pictureErrorListener.js'

import { Commons } from './utils/commons'
import { Translate } from './utils/translate.js'
import { ColorTheme } from './utils/colorTheme.js'
import { Events } from './utils/events'
import { NotificationUtils } from './utils/notificationsUtils'
import { Chat } from './utils/chat.js'
import { Countries } from './utils/countries.js'
import { QuickStorage } from './utils/quickStorage.js'
import { WorkerUtils } from './service-worker/workerUtils.js'
import { Network } from './utils/network.js'
import { PermissionsManager } from './utils/permissionsManager.js'

Events.init()
Events.initKeepWorkerAlivePing()
QuickStorage.init()
Translate.init()
ColorTheme.init()
// Chat.init()
WorkerUtils.init()
NotificationUtils.init()
PermissionsManager.init()
Network.initNetworkStateListener()

import { createApp } from 'vue'
import App from './App.vue'
import router from './router'

const app = createApp(App)

app.use(router)

app.config.globalProperties.$Commons = Commons
app.config.globalProperties.$QuickStorage = QuickStorage
app.config.globalProperties.$Countries = Countries
app.config.globalProperties.$NotificationUtils = NotificationUtils
app.config.globalProperties.$Events = Events
app.config.globalProperties.$Chat = Chat
app.config.globalProperties.$Translate = Translate
app.config.globalProperties.$ColorTheme = ColorTheme
app.config.globalProperties.$t = Translate.$t

app.mount('#app')
